import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'

export const getWikiPage = async (path: string) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Wiki`, JSON.stringify(path), {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}
